"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.fileNameWithoutExtension = exports.getTimeAsCharacters = exports.escapeRegex = exports.isNonEmptyString = exports.snakeCaseToCamelCase = exports.camelCaseToSnakeCase = exports.upperCaseFirst = exports.lowerCaseFirst = exports.escapeString = exports.camelCaseToText = void 0;
const underscore_1 = require("underscore");
const json_utils_1 = require("./json-utils");
/**
 * Converts "firstName" to "First Name"
 */
function camelCaseToText(str) {
    if (typeof str !== "string")
        return str;
    return str.replace(/([A-Z])/g, " $1").replace(/^./, (s) => s.toUpperCase());
}
exports.camelCaseToText = camelCaseToText;
function escapeString(str) {
    return str === null || str === void 0 ? void 0 : str.replace(/\n/g, "\\n").replace(/&/g, "\\u0026").replace(/\r/g, "\\r").replace(/\t/g, "\\t").replace(/\f/g, "\\f").replace(/\\/g, "\\").replace(/"/g, '\\"').replace(/'f/g, "\\'");
}
exports.escapeString = escapeString;
/** Lowercases only the first letter. Useful if you need to convert UpperPascalCase to lowerPascalCase */
function lowerCaseFirst(str) {
    if (typeof str !== "string")
        return str;
    return str.charAt(0).toLowerCase() + str.slice(1);
}
exports.lowerCaseFirst = lowerCaseFirst;
/** Uppercases only the first letter. Useful if you need to convert lowerPascalCase to UpperPascalCase */
function upperCaseFirst(str) {
    if (typeof str !== "string")
        return str;
    return str.charAt(0).toUpperCase() + str.slice(1);
}
exports.upperCaseFirst = upperCaseFirst;
/** Converts "HelloWorld" to "hello_world" */
function camelCaseToSnakeCase(str) {
    return lowerCaseFirst(str).replace(/[A-Z]/g, (letter) => `_${letter.toLowerCase()}`);
}
exports.camelCaseToSnakeCase = camelCaseToSnakeCase;
/** Converts "hello_world" to "HelloWorld" */
function snakeCaseToCamelCase(str, lowerCamelCase = false) {
    const camelCase = str.replace(/([-_][a-zA-Z])/g, (group) => group.toUpperCase().replace("-", "").replace("_", ""));
    if (lowerCamelCase)
        return lowerCaseFirst(camelCase);
    return upperCaseFirst(camelCase);
}
exports.snakeCaseToCamelCase = snakeCaseToCamelCase;
/** returns true if given string is typeof string & not undefined & not null & not '' */
function isNonEmptyString(str) {
    return (0, underscore_1.isString)(str) && !(0, underscore_1.isUndefined)(str) && !(0, underscore_1.isEmpty)(str) && str !== null && str !== undefined;
}
exports.isNonEmptyString = isNonEmptyString;
function escapeRegex(str) {
    // eslint-disable-next-line no-useless-escape
    return str.replace(/[-\/\\^$*+?.()|[\]{}]/g, "\\$&");
}
exports.escapeRegex = escapeRegex;
function getTimeAsCharacters(timestamp = Date.now()) {
    return timestamp
        .toString()
        .split("")
        .map((n) => (Number(n) + 10).toString(36))
        .join("");
}
exports.getTimeAsCharacters = getTimeAsCharacters;
function fileNameWithoutExtension(fileName) {
    if (!fileName || !fileName.includes("."))
        return fileName;
    return (0, json_utils_1.removeLastPropertyName)(fileName);
}
exports.fileNameWithoutExtension = fileNameWithoutExtension;
